import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../../staff/StaffSideMenu";
import API_URL from "../../../api/API";
import { useStaffAuthContext } from "../../staff/useStaffAuthContext";
import { useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import { DndContext, useDroppable, useDraggable } from "@dnd-kit/core";
import SingleSelectExerciseList from "../../component/SingleSelectExerciseList";
import {
  MdAdd,
  MdKeyboardArrowDown,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdKeyboardArrowUp,
} from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import { RiDeleteBin4Line } from "react-icons/ri";

const DotedSvg = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.99967 8.66732C6.36786 8.66732 6.66634 8.36884 6.66634 8.00065C6.66634 7.63246 6.36786 7.33398 5.99967 7.33398C5.63148 7.33398 5.33301 7.63246 5.33301 8.00065C5.33301 8.36884 5.63148 8.66732 5.99967 8.66732Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.99967 3.99935C6.36786 3.99935 6.66634 3.70087 6.66634 3.33268C6.66634 2.96449 6.36786 2.66602 5.99967 2.66602C5.63148 2.66602 5.33301 2.96449 5.33301 3.33268C5.33301 3.70087 5.63148 3.99935 5.99967 3.99935Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.99967 13.3333C6.36786 13.3333 6.66634 13.0349 6.66634 12.6667C6.66634 12.2985 6.36786 12 5.99967 12C5.63148 12 5.33301 12.2985 5.33301 12.6667C5.33301 13.0349 5.63148 13.3333 5.99967 13.3333Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99967 8.66732C10.3679 8.66732 10.6663 8.36884 10.6663 8.00065C10.6663 7.63246 10.3679 7.33398 9.99967 7.33398C9.63148 7.33398 9.33301 7.63246 9.33301 8.00065C9.33301 8.36884 9.63148 8.66732 9.99967 8.66732Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99967 3.99935C10.3679 3.99935 10.6663 3.70087 10.6663 3.33268C10.6663 2.96449 10.3679 2.66602 9.99967 2.66602C9.63148 2.66602 9.33301 2.96449 9.33301 3.33268C9.33301 3.70087 9.63148 3.99935 9.99967 3.99935Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99967 13.3333C10.3679 13.3333 10.6663 13.0349 10.6663 12.6667C10.6663 12.2985 10.3679 12 9.99967 12C9.63148 12 9.33301 12.2985 9.33301 12.6667C9.33301 13.0349 9.63148 13.3333 9.99967 13.3333Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const AdminStrengthProductBuilder = () => {
  const { staff } = useStaffAuthContext();
  const { template_id } = useParams();
  const navigate = useNavigate();

  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);

  const [activeWeek, setActiveWeek] = useState(1);
  const [activeDay, setActiveDay] = useState("monday");
  const [weeksData, setWeeksData] = useState({}); // Structure: { '1': { monday: {...}, ... }, '2': {}, ... }

  const weeks = Array.from({ length: 24 }, (_, i) => i + 1);
  const days = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  const [showAddExerciseForm, setShowAddExerciseForm] = useState(false);
  const [exerciseLibrary, setExerciseLibrary] = useState([]);
  const [selectedExerciseId, setSelectedExerciseId] = useState("");

  const [openIndexes, setOpenIndexes] = useState([]);

  const [showAddSupersetForm, setShowAddSupersetForm] = useState(false);
  const [newSupersetTitle, setNewSupersetTitle] = useState("");

  const [showSupersetAddForm, setShowSupersetAddForm] = useState(null); // store item._id
  const [selectedSupersetExerciseId, setSelectedSupersetExerciseId] =
    useState("");

  const [openSupersetExercise, setOpenSupersetExercise] = useState({
    itemId: null,
    sIdx: null,
  });

  //circuit
  const [showAddCircuitForm, setShowAddCircuitForm] = useState(false);
  const [newCircuitTitle, setNewCircuitTitle] = useState("");

  const [showCircuitAddForm, setShowCircuitAddForm] = useState(null); // store item._id
  const [selectedCircuitExerciseId, setSelectedCircuitExerciseId] =
    useState("");

  const [openCircuitExercise, setOpenCircuitExercise] = useState({
    itemId: null,
    sIdx: null,
  });

  //reorder top level
  const [reorderMode, setReorderMode] = useState(false);

  const [ssreorderMode, setSSReorderMode] = useState(false);
  const [ccreorderMode, setCCReorderMode] = useState(false);

  //training focus section
  const [trainingFocuses, setTrainingFocuses] = useState([]);
  const [error, setError] = useState(null);
  const [trainingFocus, setTrainingFocus] = useState("");
  const [trainingPhase, setTrainingPhase] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchTrainingFocuses = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          API_URL.ADMIN_STRENGTH_TEMPLATE_TRAINING_FOCUS_MANAGE,
          {
            headers: { Authorization: `Bearer ${staff.token}` },
          },
        );
        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          setTrainingFocuses(result.data);
        } else {
          setTrainingFocuses([]);
          setError("Unexpected response format.");
        }
      } catch (err) {
        console.error("Failed to fetch training focuses:", err);
        setError("Unable to load training focuses");
      } finally {
        setLoading(false);
      }
    };

    fetchTrainingFocuses();
  }, []);

  const [expandedRow, setExpandedRow] = useState(null);

  const toggleExpand = (id) => {
    setExpandedRow((prev) => (prev === id ? null : id));
  };

  const handleUseFocusTemplate = (template) => {
    const confirmCopy = window.confirm(
      `Are you sure you want to use the template "${template.training_focus}" for Week ${activeWeek} – ${activeDay}? This will overwrite any existing exercises for that day.`,
    );

    if (!confirmCopy) return;

    // Optional: set top-level labels
    //setTrainingFocus(template.training_focus);
    //setTrainingPhase(template.training_phase);

    // Inject template items into the correct week/day
    setWeeksData((prev) => {
      const updated = { ...prev };

      // Ensure week object exists
      if (!updated[activeWeek]) {
        updated[activeWeek] = {};
      }

      // Ensure day object exists
      if (!updated[activeWeek][activeDay]) {
        updated[activeWeek][activeDay] = { items: [] };
      }

      // Replace items for the day
      updated[activeWeek][activeDay] = {
        ...updated[activeWeek][activeDay], // keep existing items if needed
        training_focus: template.training_focus,
        training_phase: template.training_phase,
        items: template.items || [],
      };

      console.log(updated[activeWeek][activeDay].items);

      return updated;
    });
  };

  //end of training focus section

  useEffect(() => {
    const fetchExercises = async () => {
      try {
        const res = await fetch(`${API_URL.GET_EXERCISE_LIBRARY_LIST_ADMIN}`, {
          headers: {
            Authorization: `Bearer ${staff?.token}`,
          },
        });
        const data = await res.json();
        console.log(data);
        if (res.ok && data?.exercises) {
          setExerciseLibrary(data.exercises);
        } else {
          console.error("Error loading exercises");
        }
      } catch (err) {
        console.error("Failed to fetch exercise library", err);
      }
    };

    if (staff?.token) fetchExercises();
  }, [staff?.token]);

  // 🧠 Initialize weeksData based on template
  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        const res = await fetch(
          `${API_URL.ADMIN_GET_STRENGTH_PRODUCT}${template_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${staff?.token}`,
            },
          },
        );

        const data = await res.json();

        if (res.ok && data.data) {
          setTemplate(data.data);
          const transformedWeeks = {};

          // Populate the weeksData structure
          data.data.weeks?.forEach((weekObj) => {
            transformedWeeks[weekObj.weekNumber] = { ...weekObj.days };
          });

          setWeeksData(transformedWeeks);
        } else {
          console.error("Failed to load template:", data.message);
        }
      } catch (error) {
        console.error("Error fetching template:", error);
      } finally {
        setLoading(false);
      }
    };

    if (staff?.token && template_id) {
      fetchTemplate();
    }
  }, [staff?.token, template_id]);

  const fetchStrengthExerciseData = async () => {
    if (!template_id) return;

    try {
      const res = await fetch(
        `${API_URL.ADMIN_GET_STRENGTH_EXERCISE}${template_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff?.token}`,
          },
        },
      );

      const data = await res.json();
      console.log(data.exercises);

      if (res.ok) {
        setWeeksData(() => {
          const weeks = data?.data?.weeks || [];
          const structured = {};

          for (const week of weeks) {
            const weekNumber = week.weekNumber;
            structured[weekNumber] = {};

            for (const day in week.days) {
              structured[weekNumber][day] = {
                items: week.days[day]?.items || [],
              };
            }
          }

          return structured;
        });
      } else {
        console.error(
          "Failed to fetch strength data:",
          data.message || data.error,
        );
      }
    } catch (err) {
      console.error("Error fetching strength data:", err);
    }
  };

  useEffect(() => {
    fetchStrengthExerciseData();
  }, [template_id]);

  const handleDeleteExercise = async (itemId) => {
    if (typeof window !== "undefined") {
      const confirmed = window.confirm(
        "Are you sure you want to delete this item?",
      );
      if (!confirmed) return;
    }

    try {
      await fetch(`${API_URL.ADMIN_DELETE_STRENGTH_EXERCISE}${itemId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff?.token}`,
        },
      });

      await fetchStrengthExerciseData(); // Refresh from DB
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Failed to delete item.");
    }
  };

  const handleAddExercise = async () => {
    if (!selectedExerciseId || !template_id) return;

    try {
      const res = await fetch(
        `${API_URL.ADMIN_ADD_STRENGTH_EXERCISE}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff?.token}`,
          },
          body: JSON.stringify({
            weekNumber: activeWeek,
            day: activeDay,
            type: "exercise",
            exercise: {
              exercise_id: selectedExerciseId,
              sets: [],
            },
          }),
        },
      );

      const data = await res.json();

      if (res.ok) {
        await fetchStrengthExerciseData(); // Refresh from DB

        setShowAddExerciseForm(false);
        setSelectedExerciseId("");
      } else {
        console.error("Failed to add exercise:", data.message || data.error);
        alert("Failed to add exercise");
      }
    } catch (err) {
      console.error("Error adding exercise:", err);
      alert("Something went wrong");
    }
  };

  const handleSaveTemplate = async () => {
    const payload = [];

    for (const weekKey in weeksData) {
      const week = weeksData[weekKey];

      const formattedWeek = {
        weekNumber: parseInt(weekKey),
        days: {},
      };

      for (const dayKey in week) {
        const day = week[dayKey];

        if (!Array.isArray(day.items)) continue;

        formattedWeek.days[dayKey] = {
          training_focus: day.training_focus || "",
          training_phase: day.training_phase || "",

          items: day.items
            .map((item, index) => {
              const base = { order_id: index + 1 }; // 👈 Start from 1

              if (item.type === "exercise") {
                return {
                  ...base,
                  type: "exercise",
                  exercise: {
                    exercise_id: item.exercise?.exercise_id,
                    sets: item.exercise?.sets || [],
                  },
                };
              }

              if (item.type === "superset") {
                return {
                  ...base,
                  type: "superset",
                  superset: {
                    title: item.superset?.title || "",
                    exercises: (item.superset?.exercises || []).map((sup) => ({
                      exercise_id: sup.exercise_id,
                      sets: sup.sets || [],
                    })),
                  },
                };
              }

              if (item.type === "circuit") {
                return {
                  ...base,
                  type: "circuit",
                  circuit: {
                    title: item.circuit?.title || "",
                    exercises: (item.circuit?.exercises || []).map((sup) => ({
                      exercise_id: sup.exercise_id,
                      sets: sup.sets || [],
                    })),
                  },
                };
              }

              return null;
            })
            .filter(Boolean),
        };
      }

      payload.push(formattedWeek);
    }

    try {
      const response = await fetch(
        `${API_URL.ADMIN_SAVE_ALL_STRENGTH_EXERCISE}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff?.token}`,
          },
          body: JSON.stringify({ weeks: payload }),
        },
      );

      const result = await response.json();

      if (!response.ok) throw new Error(result.message || "Failed to save");

      alert("Template saved successfully!");
      // Refresh the page
      window.location.reload();
    } catch (error) {
      console.error("Save failed:", error);
      alert("Failed to save template.");
    }
  };

  const addSet = (itemId) => {
    setWeeksData((prev) => {
      const updated = structuredClone(prev); // Safely deep clone
      const items = updated[activeWeek][activeDay].items;
      const item = items.find((i) => i._id === itemId);

      if (item) {
        if (!Array.isArray(item.exercise.sets)) item.exercise.sets = [];
        item.exercise.sets.push({
          reps: "",
          weight: "",
          unit: "%",
          time: "",
          goal: "",
          rest: "",
          notes: "",
        });
      }

      return updated;
    });
  };

  const updateSet = (itemId, setIdx, field, value) => {
    setWeeksData((prev) => {
      const updated = structuredClone(prev);
      const items = updated[activeWeek][activeDay].items;
      const item = items.find((i) => i._id === itemId);

      if (item && item.exercise.sets?.[setIdx]) {
        item.exercise.sets[setIdx][field] = value;
      }

      return updated;
    });
  };

  const deleteSet = (itemId, setIdx) => {
    setWeeksData((prev) => {
      const updated = structuredClone(prev);
      const items = updated[activeWeek][activeDay].items;
      const item = items.find((i) => i._id === itemId);

      if (item && item.exercise.sets?.length > setIdx) {
        item.exercise.sets.splice(setIdx, 1);
      }

      return updated;
    });
  };

  const handleAddSuperset = async () => {
    if (!newSupersetTitle.trim() || !template_id) return;

    try {
      const res = await fetch(
        `${API_URL.ADMIN_ADD_STRENGTH_EXERCISE}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff?.token}`,
          },
          body: JSON.stringify({
            weekNumber: activeWeek,
            day: activeDay,
            type: "superset",
            superset: {
              title: newSupersetTitle.trim(),
              exercises: [], // Empty for now
            },
          }),
        },
      );

      const data = await res.json();

      if (res.ok) {
        await fetchStrengthExerciseData(); // Refresh from DB

        setShowAddSupersetForm(false);
        setNewSupersetTitle("");
      } else {
        console.error("Failed to add superset:", data.message || data.error);
        alert("Failed to add superset");
      }
    } catch (err) {
      console.error("Error adding superset:", err);
      alert("Something went wrong");
    }
  };

  const handleAddSupersetExercise = async (supersetBlockId) => {
    if (!selectedSupersetExerciseId || !template_id) return;

    try {
      const res = await fetch(
        `${API_URL.ADMIN_ADD_STRENGTH_EXERCISE}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff?.token}`,
          },
          body: JSON.stringify({
            type: "superset",
            weekNumber: activeWeek,
            day: activeDay,
            supersetId: supersetBlockId,
            newExercise: {
              exercise_id: selectedSupersetExerciseId,
              sets: [],
            },
          }),
        },
      );

      const data = await res.json();

      if (res.ok) {
        await fetchStrengthExerciseData(); // Refresh view
        setSelectedSupersetExerciseId("");
        setShowSupersetAddForm(null);
      } else {
        console.error(
          "Failed to add superset exercise:",
          data.message || data.error,
        );
        alert("Failed to add superset exercise");
      }
    } catch (err) {
      console.error("Error adding superset exercise:", err);
      alert("Something went wrong");
    }
  };

  const handleDeleteSupersetExercise = async (supersetId, exerciseId) => {
    if (!template_id || !supersetId || !exerciseId) return;

    const confirmDelete = window.confirm(
      "Are you sure you want to remove this exercise?",
    );
    if (!confirmDelete) return;

    try {
      const res = await fetch(
        `${API_URL.ADMIN_DELETE_SUPERSET_EXERCISE}${exerciseId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff?.token}`,
          },
          body: JSON.stringify({
            weekNumber: activeWeek,
            day: activeDay,
            supersetId,
            exerciseId, // pass unique ID instead of index
          }),
        },
      );

      const data = await res.json();

      if (res.ok) {
        await fetchStrengthExerciseData();
      } else {
        console.error("Delete failed:", data.message);
        alert("Failed to delete exercise");
      }
    } catch (error) {
      console.error("Error deleting exercise:", error);
      alert("Something went wrong");
    }
  };

  const addSupersetSet = (itemId, supersetExerciseIdx) => {
    setWeeksData((prev) => {
      const updated = structuredClone(prev);
      const items = updated[activeWeek][activeDay].items;
      const item = items.find((i) => i._id === itemId);

      if (item && item.type === "superset") {
        const exercise = item.superset?.exercises?.[supersetExerciseIdx];
        if (exercise) {
          if (!Array.isArray(exercise.sets)) exercise.sets = [];
          exercise.sets.push({
            reps: "",
            weight: "",
            unit: "%",
            time: "",
            goal: "",
            rest: "",
            notes: "",
          });
        }
      }

      return updated;
    });
  };

  const updateSupersetSet = (
    itemId,
    supersetExerciseIdx,
    setIdx,
    field,
    value,
  ) => {
    setWeeksData((prev) => {
      const updated = structuredClone(prev);
      const items = updated[activeWeek][activeDay].items;
      const item = items.find((i) => i._id === itemId);

      if (item && item.type === "superset") {
        const exercise = item.superset?.exercises?.[supersetExerciseIdx];
        if (exercise && exercise.sets?.[setIdx]) {
          exercise.sets[setIdx][field] = value;
        }
      }

      return updated;
    });
  };

  const deleteSupersetSet = (itemId, supersetExerciseIdx, setIdx) => {
    setWeeksData((prev) => {
      const updated = structuredClone(prev);
      const items = updated[activeWeek][activeDay].items;
      const item = items.find((i) => i._id === itemId);

      if (item && item.type === "superset") {
        const exercise = item.superset?.exercises?.[supersetExerciseIdx];
        if (exercise && exercise.sets?.length > setIdx) {
          exercise.sets.splice(setIdx, 1);
        }
      }

      return updated;
    });
  };

  //curcuit related handlers
  const handleAddCircuit = async () => {
    if (!newCircuitTitle.trim() || !template_id) return;

    try {
      const res = await fetch(
        `${API_URL.ADMIN_ADD_STRENGTH_EXERCISE}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff?.token}`,
          },
          body: JSON.stringify({
            weekNumber: activeWeek,
            day: activeDay,
            type: "circuit",
            circuit: {
              title: newCircuitTitle.trim(),
              exercises: [], // Empty for now
            },
          }),
        },
      );

      const data = await res.json();

      if (res.ok) {
        await fetchStrengthExerciseData(); // Refresh from DB

        setShowAddCircuitForm(false);
        setNewCircuitTitle("");
      } else {
        console.error("Failed to add circuit:", data.message || data.error);
        alert("Failed to add circuit");
      }
    } catch (err) {
      console.error("Error adding circuit:", err);
      alert("Something went wrong");
    }
  };

  const handleAddCircuitExercise = async (circuitBlockId) => {
    if (!selectedCircuitExerciseId || !template_id) return;

    try {
      const res = await fetch(
        `${API_URL.ADMIN_ADD_STRENGTH_EXERCISE}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff?.token}`,
          },
          body: JSON.stringify({
            type: "circuit",
            weekNumber: activeWeek,
            day: activeDay,
            circuitId: circuitBlockId,
            newExercise: {
              exercise_id: selectedCircuitExerciseId,
              sets: [],
            },
          }),
        },
      );

      const data = await res.json();

      if (res.ok) {
        await fetchStrengthExerciseData(); // Refresh view
        setSelectedCircuitExerciseId("");
        setShowCircuitAddForm(null);
      } else {
        console.error(
          "Failed to add circuit exercise:",
          data.message || data.error,
        );
        alert("Failed to add circuit exercise");
      }
    } catch (err) {
      console.error("Error adding circuit exercise:", err);
      alert("Something went wrong");
    }
  };

  const handleDeleteCircuitExercise = async (circuitId, exerciseId) => {
    if (!template_id || !circuitId || !exerciseId) return;

    const confirmDelete = window.confirm(
      "Are you sure you want to remove this exercise?",
    );
    if (!confirmDelete) return;

    try {
      const res = await fetch(
        `${API_URL.ADMIN_DELETE_CIRCUIT_EXERCISE}${exerciseId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff?.token}`,
          },
          body: JSON.stringify({
            weekNumber: activeWeek,
            day: activeDay,
            circuitId,
            exerciseId, // pass unique ID instead of index
          }),
        },
      );

      const data = await res.json();

      if (res.ok) {
        await fetchStrengthExerciseData();
      } else {
        console.error("Delete failed:", data.message);
        alert("Failed to delete exercise");
      }
    } catch (error) {
      console.error("Error deleting exercise:", error);
      alert("Something went wrong");
    }
  };

  const addCircuitSet = (itemId, circuitExerciseIdx) => {
    setWeeksData((prev) => {
      const updated = structuredClone(prev);
      const items = updated[activeWeek][activeDay].items;
      const item = items.find((i) => i._id === itemId);

      if (item && item.type === "circuit") {
        const exercise = item.circuit?.exercises?.[circuitExerciseIdx];
        if (exercise) {
          if (!Array.isArray(exercise.sets)) exercise.sets = [];
          exercise.sets.push({
            reps: "",
            weight: "",
            unit: "%",
            time: "",
            goal: "",
            rest: "",
            notes: "",
          });
        }
      }

      return updated;
    });
  };

  const updateCircuitSet = (
    itemId,
    circuitExerciseIdx,
    setIdx,
    field,
    value,
  ) => {
    setWeeksData((prev) => {
      const updated = structuredClone(prev);
      const items = updated[activeWeek][activeDay].items;
      const item = items.find((i) => i._id === itemId);

      if (item && item.type === "circuit") {
        const exercise = item.circuit?.exercises?.[circuitExerciseIdx];
        if (exercise && exercise.sets?.[setIdx]) {
          exercise.sets[setIdx][field] = value;
        }
      }

      return updated;
    });
  };

  const deleteCircuitSet = (itemId, circuitExerciseIdx, setIdx) => {
    setWeeksData((prev) => {
      const updated = structuredClone(prev);
      const items = updated[activeWeek][activeDay].items;
      const item = items.find((i) => i._id === itemId);

      if (item && item.type === "circuit") {
        const exercise = item.circuit?.exercises?.[circuitExerciseIdx];
        if (exercise && exercise.sets?.length > setIdx) {
          exercise.sets.splice(setIdx, 1);
        }
      }

      return updated;
    });
  };

  //drag and drop items
  const handleItemDragEnd = (event, weekKey, dayKey) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    const items = [...weeksData[weekKey][dayKey].items];

    const oldIndex = items.findIndex((item) => item._id === active.id);
    const newIndex = items.findIndex((item) => item._id === over.id);

    if (oldIndex === -1 || newIndex === -1) return;

    const [movedItem] = items.splice(oldIndex, 1);
    items.splice(newIndex, 0, movedItem);

    setWeeksData((prev) => ({
      ...prev,
      [weekKey]: {
        ...prev[weekKey],
        [dayKey]: {
          ...prev[weekKey][dayKey],
          items,
        },
      },
    }));
  };

  const handleSupersetReorderEnd = (event, weekKey, dayKey, itemId) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setWeeksData((prev) => {
      const items = [...prev[weekKey][dayKey].items];

      const updatedItems = items.map((item) => {
        if (item._id !== itemId || !item.superset?.exercises) return item;

        const exercises = [...item.superset.exercises];
        const oldIndex = exercises.findIndex((ex) => ex._id === active.id);
        const newIndex = exercises.findIndex((ex) => ex._id === over.id);

        if (oldIndex === -1 || newIndex === -1) return item;

        const [moved] = exercises.splice(oldIndex, 1);
        exercises.splice(newIndex, 0, moved);

        return {
          ...item,
          superset: {
            ...item.superset,
            exercises,
          },
        };
      });

      return {
        ...prev,
        [weekKey]: {
          ...prev[weekKey],
          [dayKey]: {
            ...prev[weekKey][dayKey],
            items: updatedItems,
          },
        },
      };
    });
  };

  const handleCircuitReorderEnd = (event, weekKey, dayKey, itemId) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setWeeksData((prev) => {
      const items = [...prev[weekKey][dayKey].items];

      const updatedItems = items.map((item) => {
        if (item._id !== itemId || !item.circuit?.exercises) return item;

        const exercises = [...item.circuit.exercises];
        const oldIndex = exercises.findIndex((ex) => ex._id === active.id);
        const newIndex = exercises.findIndex((ex) => ex._id === over.id);

        if (oldIndex === -1 || newIndex === -1) return item;

        const [moved] = exercises.splice(oldIndex, 1);
        exercises.splice(newIndex, 0, moved);

        return {
          ...item,
          circuit: {
            ...item.circuit,
            exercises,
          },
        };
      });

      return {
        ...prev,
        [weekKey]: {
          ...prev[weekKey],
          [dayKey]: {
            ...prev[weekKey][dayKey],
            items: updatedItems,
          },
        },
      };
    });
  };

  //master workoputs
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const filteredTemplates = trainingFocuses.filter(
    (template) =>
      template.training_focus
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      template.training_phase.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const paginatedTemplates = filteredTemplates.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const totalPages = Math.ceil(filteredTemplates.length / itemsPerPage);

  //video functions
  const [videoUrlToPlay, setVideoUrlToPlay] = useState(null);

  const getYouTubeVideoId = (url) => {
    const match = url.match(
      /(?:youtube\.com.*(?:\/|v=)|youtu\.be\/)([^&\n?#]+)/,
    );
    return match ? match[1] : null;
  };

  const getExerciseObject = (exerciseId, exerciseLibrary) => {
    const id = typeof exerciseId === "object" ? exerciseId._id : exerciseId;
    return exerciseLibrary.find((ex) => ex._id === id);
  };

  const TIME_OPTIONS = [
    ...Array.from({ length: 6 }, (_, i) => `${(i + 1) * 10}s`), // 10s to 60s
    ...Array.from({ length: 5 }, (_, i) => `${i + 1} min`), // 1 min to 5 min
  ];

  function normalizeTemplateItem(item) {
    if (item.type === "exercise") {
      return {
        type: "exercise",
        exercise_id: item.exercise?.exercise_id || item.exercise_id,
      };
    }

    if (item.type === "superset") {
      return {
        type: "superset",
        superset: {
          title: item.superset.title,
          exercises: item.superset.exercises.map((ex) => ({
            exercise_id: ex.exercise_id || ex.exercise?.exercise_id,
          })),
        },
      };
    }

    if (item.type === "circuit") {
      return {
        type: "circuit",
        circuit: {
          title: item.circuit.title,
          exercises: item.circuit.exercises.map((ex) => ({
            exercise_id: ex.exercise_id || ex.exercise?.exercise_id,
          })),
        },
      };
    }

    return item;
  }

  return (
    <div className="flex md:h-screen font-inter">
      <StaffSideMenu />
      <div className="md:flex-1 w-full bg-bgBase relative flex max-md:flex-col">
        {/* Week Tabs */}
        <div className="max-md:p-5 md:w-44 flex-none md:overflow-y-auto show-scrollbar inline-block bg-white border-r border-tblBorder">
          <div className="p-2 max-md:!pt-0 md:p-6 border-b border-tblBorder">
            <div className="text-dark text-xl font-medium capitalize max-md:ml-12">
              weeks
            </div>
          </div>
          <div className="flex max-md:flex-wrap md:flex-col">
            {weeks.map((week) => (
              <button
                key={week}
                onClick={() => setActiveWeek(week)}
                className={`p-2 md:px-5 md:py-4 text-start text-sm font-medium max-md:border-b-2 md:border-l-4 tracking-tighter ${
                  activeWeek === week
                    ? "bg-[#F3F4F6] text-dark border-dark"
                    : "bg-white text-slate100 border-transparent"
                }`}
              >
                Week {week}
              </button>
            ))}
          </div>
        </div>

        <div className="w-full overflow-auto inline-flex flex-col">
          <div className="bg-white md:sticky md:top-0 md:z-10">
            {/* Top Right Buttons */}
            <div className="w-full max-w-[1400px] space-y-5 py-3 md:py-5 px-5 md:px-8 border-b border-tblBorder">
              {/* go back / save template */}
              <div className="flex flex-wrap justify-between gap-5">
                <button
                  onClick={() => navigate(-1)}
                  className="text-slate100 font-inter font-normal text-sm leading-tight flex items-center gap-2 hover:underline"
                >
                  <MdKeyboardArrowLeft color="#666666" size={20} /> Go Back
                </button>

                <div className="flex items-center gap-5">
                  {template && (
                    <>
                      <div className="p-2 rounded-md">
                        <span className="text-slate100 text-sm font-medium">
                          {template.status}
                        </span>
                      </div>
                    </>
                  )}
                  <button
                    onClick={handleSaveTemplate}
                    className="px-6 py-2.5 h-fit bg-dark text-white font-inter font-normal text-sm rounded-lg hover:bg-black"
                  >
                    Save Template
                  </button>
                </div>
              </div>

              {/* Template Info */}
              <div>
                {loading ? (
                  <div className="text-gray-500 text-sm font-normal">
                    Loading template details...
                  </div>
                ) : template ? (
                  <>
                    <div>
                      <span className="text-dark text-2xl font-medium">
                        {template.title}
                      </span>
                    </div>
                    {/* <div>
                      <span className="text-gray-500">Status:</span>{" "}
                      <span className="font-medium">{template.status}</span>
                    </div> */}
                  </>
                ) : (
                  <div className="text-sm font-normal text-red-500">
                    Template not found.
                  </div>
                )}
              </div>
            </div>
            {/* days box */}
            <div className="w-full max-w-[1400px] space-y-5 py-3 md:py-5 px-5 md:px-8 border-b border-tblBorder">
              {/* active week */}
              <h3 className="text-dark text-lg lg:text-2xl font-medium capitalize">
                {/* Week {activeWeek} – {activeDay} */}
                Week {activeWeek}
              </h3>

              {/* Day Tabs */}
              <div className="inline-flex flex-wrap gap-y-2 gap-x-3">
                {days.map((day) => (
                  <div>
                    <button
                      key={day}
                      onClick={() => setActiveDay(day)}
                      className={`w-full px-3 py-2 lg:px-6 lg:py-3 text-sm font-medium leading-none rounded-md lg:rounded-xl capitalize border ${
                        activeDay === day
                          ? "text-white bg-dark"
                          : "bg-white text-dark hover:bg-gray-100"
                      }`}
                    >
                      {day}
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Builder UI */}
          <div className="bg-bgBase py-10 px-5 md:px-8">
            {/* Placeholder for Day UI */}
            {/* <div className="p-4 md:p-6 bg-white border border-tblBorder rounded-10"> */}
            {/* Action Buttons */}
            <div className="w-full max-w-screen-lg">
              <div className="flex flex-wrap justify-end gap-2 mb-6">
                <button
                  onClick={() => setShowAddExerciseForm(true)}
                  className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                >
                  <MdAdd color="#000" /> Add Exercise
                </button>
                <button
                  onClick={() => setShowAddSupersetForm(true)}
                  className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                >
                  <MdAdd color="#000" /> Add Superset
                </button>

                <button
                  onClick={() => setShowAddCircuitForm(true)}
                  className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                >
                  <MdAdd color="#000" /> Add Circuit
                </button>

                <button
                  onClick={() => setReorderMode(!reorderMode)}
                  className={`px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl`}
                >
                  {reorderMode ? (
                    "Back to Editor"
                  ) : (
                    <>
                      <DotedSvg /> Reorder
                    </>
                  )}
                </button>
              </div>
              
              {/* forms */}
              {/* add exercise / add circuit / add superset */}
                {/* Add Exercise Form */}
                {showAddExerciseForm && (
                  <div className="pb-6">
                    <div className="bg-bgBase p-4 border border-tblBorder rounded-10">
                      <label className="block text-sm font-medium mb-2">
                        Select Exercise
                      </label>
                      <SingleSelectExerciseList
                        exercises={exerciseLibrary}
                        value={selectedExerciseId}
                        onChange={(val) => setSelectedExerciseId(val)}
                      />

                      <div className="mt-4 flex gap-2 items-end">
                        <button
                          onClick={handleAddExercise}
                          className="px-4 py-2 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black h-fit"
                        >
                          Add
                        </button>

                        <button
                          onClick={() => setShowAddExerciseForm(false)}
                          className="px-4 py-2 bg-white border border-tblBorder text-dark font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black hover:text-white h-fit"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Superset form add title */}
                {showAddSupersetForm && (
                  <div className="pb-6">
                    <div className="bg-bgBase p-4 border border-tblBorder rounded-10">
                      <div className="flex max-md:flex-wrap gap-2">
                        <div className="w-full">
                          <input
                            type="text"
                            value={newSupersetTitle}
                            onChange={(e) =>
                              setNewSupersetTitle(e.target.value)
                            }
                            placeholder="Enter Superset Title"
                            className="w-full px-3 py-2.5 border border-black/10 rounded-lg font-inter font-normal text-sm leading-none"
                          />
                        </div>

                        <div className=" flex-none flex gap-2 items-end">
                          <button
                            onClick={handleAddSuperset}
                            className="px-4 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black h-fit"
                          >
                            Add Superset
                          </button>
                          <button
                            onClick={() => {
                              setShowAddSupersetForm(false);
                              setNewSupersetTitle("");
                            }}
                            className="px-4 py-2.5 bg-white border border-tblBorder text-dark font-inter font-normal text-sm leading-tight rounded-lg
                            hover:bg-black hover:text-white h-fit"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Circuit form add title */}
                {showAddCircuitForm && (
                  <div className="pb-6">
                    <div className="bg-bgBase p-4 border border-tblBorder rounded-10">
                      <div className="flex max-md:flex-wrap gap-2">
                        <div className="w-full">
                          <input
                            type="text"
                            value={newCircuitTitle}
                            onChange={(e) =>
                              setNewCircuitTitle(e.target.value)
                            }
                            placeholder="Enter Circuit Title"
                            className="w-full px-3 py-2.5 border border-black/10 rounded-lg font-inter font-normal text-sm leading-none"
                          />
                        </div>

                        <div className="flex-none flex gap-2 items-end">
                          <button
                            onClick={handleAddCircuit}
                            className="px-4 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black h-fit"
                          >
                            Add Circuit
                          </button>
                          <button
                            onClick={() => {
                              setShowAddCircuitForm(false);
                              setNewCircuitTitle("");
                            }}
                            className="px-4 py-2.5 bg-white border border-tblBorder text-dark font-inter font-normal text-sm leading-tight 
                          rounded-lg hover:bg-black hover:text-white h-fit"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* forms ended */}
            </div>

            <div>
              {reorderMode ? (
                // This block is outside the main UI fragment
                <div className="p-4 border border-tblBorder bg-white rounded-10">
                  <h2 className="text-lg font-medium mb-2">Reorder Mode</h2>
                  {/* 👉 Add your reorder drag-and-drop UI here */}
                  {/* Example placeholder: */}
                  <DndContext
                    onDragEnd={(event) =>
                      handleItemDragEnd(event, activeWeek, activeDay)
                    }
                  >
                    {weeksData?.[activeWeek]?.[activeDay]?.items?.map(
                      (item, idx) => {
                        const itemId = item._id || `item-${idx}`; // fallback if _id not available
                        return (
                          <DroppableEX key={itemId} id={itemId}>
                            <DraggableEXItem
                              key={itemId}
                              id={itemId}
                              itemIndex={idx}
                              item={item}
                            />
                          </DroppableEX>
                        );
                      },
                    )}
                  </DndContext>
                </div>
              ) : (
                <>
                  {/* Section to load all existing data */}
                  {weeksData?.[activeWeek]?.[activeDay]?.items?.length > 0 ? (
                  <div className="w-full max-w-screen-lg">
                    <div className="space-y-2 p-4 md:p-6 bg-white border border-tblBorder rounded-10">
                      {weeksData[activeWeek][activeDay].items.map(
                        (item, idx) => {
                          const isOpen = openIndexes.includes(idx);

                          return (
                            <details
                              key={idx}
                              open={isOpen}
                              onToggle={(e) => {
                                if (e.target.open) {
                                  setOpenIndexes((prev) => [...prev, idx]);
                                } else {
                                  setOpenIndexes((prev) =>
                                    prev.filter((i) => i !== idx),
                                  );
                                }
                              }}
                              // className="group bg-white rounded-10 border border-tblBorder overflow-hidden"
                              className={`group  ${item.type === "exercise" ? "bg-white rounded-10 border border-tblBorder overflow-hidden" : ""}`}
                            >
                              <summary
                                className={`flex justify-between items-center gap-4 ${item.type === "exercise" ? "bg-tblHead py-3 px-4 flex justify-between items-center gap-4" : "mt-4"}`}
                              > 
                                {/* <span> */}
                                {item.type === "exercise" && (
                                  <div className="w-full flex max-[430px]:flex-col max-[430px]:items-start items-center gap-4">
                                    {(() => {
                                      const exerciseObj = getExerciseObject(
                                        item.exercise?.exercise_id,
                                        exerciseLibrary,
                                      );
                                      return (
                                        exerciseObj?.video_url && (
                                          <div className="relative flex-none size-12 md:size-16 border border-tblBorder rounded-lg">
                                            <img
                                              src={`https://img.youtube.com/vi/${getYouTubeVideoId(exerciseObj.video_url)}/0.jpg`}
                                              alt="Video thumbnail"
                                              className="w-full h-full rounded-lg object-cover"
                                            />
                                            <button
                                              className="text-white text-xl absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setVideoUrlToPlay(
                                                  exerciseObj.video_url,
                                                );
                                              }}
                                            >
                                              ▶
                                            </button>
                                          </div>
                                        )
                                      );
                                    })()}
                                    <div className="w-full">
                                      <span className="block text-slate100 font-normal text-sm mb-1">
                                        Exercise:
                                      </span>
                                      <p className="w-full bg-white border border-tblBorder font-normal text-sm text-dark py-2.5 px-3 rounded-md outline-none">
                                        {item.exercise?.exercise_id?.title}
                                      </p>
                                    </div>
                                  </div>
                                )}
                                {item.type === "superset" && (
                                  <>
                                    <div className="flex flex-wrap items-center gap-3">
                                      <div className="text-slate100 text-xs font-medium uppercase">
                                        <span className="mr-1">Superset:</span>
                                        {item.superset?.title}
                                      </div>
                                      <button
                                        onClick={() =>
                                          setSSReorderMode((prev) =>
                                            prev === item._id ? null : item._id,
                                          )
                                        }
                                        className="px-4 py-2.5 items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl hidden group-open:flex"
                                      >
                                        {ssreorderMode === item._id ? (
                                          "Done Reordering"
                                        ) : (
                                          <>
                                            <DotedSvg /> Reorder
                                          </>
                                        )}
                                      </button>
                                    </div>
                                  </>
                                )}
                                {item.type === "circuit" && (
                                  <div className="flex flex-wrap items-center gap-3">
                                    <div className="text-slate100 text-xs font-medium uppercase">
                                      <span className="mr-1">Circuit:</span>
                                      {item.circuit?.title}
                                    </div>
                                    <button
                                      onClick={() =>
                                        setCCReorderMode((prev) =>
                                          prev === item._id ? null : item._id,
                                        )
                                      }
                                      className="px-4 py-2.5 items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl hidden group-open:flex"
                                    >
                                      {ccreorderMode === item._id ? (
                                        "Done Reordering"
                                      ) : (
                                        <>
                                          {" "}
                                          <DotedSvg /> Reorder{" "}
                                        </>
                                      )}
                                    </button>
                                  </div>
                                )}
                                {/* </span> */}

                                <div className="flex-none flex items-center gap-2 text-xs text-gray-500">
                                  {/* Delete button */}
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteExercise(item._id);
                                    }}
                                    title="Delete item"
                                    className="p-2 rounded hover:bg-gray-200"
                                  >
                                    <RiDeleteBin4Line
                                      color="#666666"
                                      size={20}
                                    />
                                  </button>

                                  {/* Toggle arrow */}
                                  <div className="p-2 rounded hover:bg-gray-200">
                                    <MdKeyboardArrowDown
                                      color="#6A7282"
                                      size={20}
                                      className="group-open:rotate-180"
                                    />
                                  </div>
                                </div>
                              </summary>

                              <div
                                className={`space-y-6 ${item.type === "exercise" ? "p-4 border-t border-tblBorder" : ""}`}
                              >
                                {item.type === "exercise" && (
                                  <div>
                                    <div className="space-y-6 mb-2">
                                      {item.exercise?.sets?.map(
                                        (set, setIdx) => (
                                          <>
                                            <div
                                              key={setIdx}
                                              className="space-y-4"
                                            >
                                              <div className="p-3 bg-tblHead border border-tblBorder rounded-10 flex items-center justify-between gap-3">
                                                <div className="flex flex-wrap gap-3">
                                                  <div className="min-w-20 flex-1">
                                                    <input
                                                      type="number"
                                                      placeholder="Reps"
                                                      value={set.reps || ""}
                                                      className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                      onChange={(e) =>
                                                        updateSet(
                                                          item._id,
                                                          setIdx,
                                                          "reps",
                                                          e.target.value,
                                                        )
                                                      }
                                                    />
                                                    <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                      reps
                                                    </label>
                                                  </div>

                                                  <div className="min-w-20 flex-1">
                                                    <input
                                                      type="number"
                                                      placeholder="Weight"
                                                      value={set.weight || ""}
                                                      className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                      onChange={(e) =>
                                                        updateSet(
                                                          item._id,
                                                          setIdx,
                                                          "weight",
                                                          e.target.value,
                                                        )
                                                      }
                                                    />
                                                    <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                      weight
                                                    </label>
                                                  </div>

                                                  <div className="min-w-20 flex-1">
                                                    <select
                                                      value={set.unit || "%"}
                                                      onChange={(e) =>
                                                        updateSet(
                                                          item._id,
                                                          setIdx,
                                                          "unit",
                                                          e.target.value,
                                                        )
                                                      }
                                                      className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                    >
                                                      <option value="%">
                                                        %
                                                      </option>
                                                      <option value="hide">
                                                        Hide
                                                      </option>
                                                      <option value="time">
                                                        Time
                                                      </option>
                                                    </select>
                                                    <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                      unit
                                                    </label>
                                                  </div>
                                                  {/* Time Dropdown if unit === "time" */}
                                                  {set.unit === "time" && (
                                                    <div className="min-w-20 flex-1">
                                                      <select
                                                        value={set.time || ""}
                                                        onChange={(e) =>
                                                          updateSet(
                                                            item._id,
                                                            setIdx,
                                                            "time",
                                                            e.target.value,
                                                          )
                                                        }
                                                        className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                      >
                                                        <option value="">
                                                          {" "}
                                                          Select time{" "}
                                                        </option>
                                                        {TIME_OPTIONS.map(
                                                          (label) => (
                                                            <option
                                                              key={label}
                                                              value={label}
                                                            >
                                                              {" "}
                                                              {label}{" "}
                                                            </option>
                                                          ),
                                                        )}
                                                      </select>
                                                      <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                        Time
                                                      </label>
                                                    </div>
                                                  )}

                                                  <div className="min-w-20 flex-1">
                                                    <select
                                                      value={set.goal || ""}
                                                      onChange={(e) =>
                                                        updateSet(
                                                          item._id,
                                                          setIdx,
                                                          "goal",
                                                          e.target.value,
                                                        )
                                                      }
                                                      className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                    >
                                                      <option value="">
                                                        &mdash; Goal &mdash;
                                                      </option>
                                                      <option value="< 0.5 m/s (Absolute Strength)">
                                                        &lt; 0.5 m/s (Absolute
                                                        Strength)
                                                      </option>
                                                      <option value="0.5 - 0.75 m/s (Accelerative Strength)">
                                                        0.5 - 0.75 m/s
                                                        (Accelerative Strength)
                                                      </option>
                                                      <option value="0.75 - 1 m/s (Strength Speed)">
                                                        0.75 - 1 m/s (Strength
                                                        Speed)
                                                      </option>
                                                      <option value="1 - 1.3 m/s (Speed Strength)">
                                                        1 - 1.3 m/s (Speed
                                                        Strength)
                                                      </option>
                                                      <option value="> 1.3 m/s (Starting Strength)">
                                                        &gt; 1.3 m/s (Starting
                                                        Strength)
                                                      </option>
                                                      <option value="> 2 m/s (Speed)">
                                                        &gt; 2 m/s (Speed)
                                                      </option>
                                                    </select>
                                                    <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                      Goal
                                                    </label>
                                                  </div>

                                                  <div className="min-w-20 flex-1">
                                                    <input
                                                      type="text"
                                                      placeholder="Rest"
                                                      value={set.rest || ""}
                                                      className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                      onChange={(e) =>
                                                        updateSet(
                                                          item._id,
                                                          setIdx,
                                                          "rest",
                                                          e.target.value,
                                                        )
                                                      }
                                                    />
                                                    <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                      Rest
                                                    </label>
                                                  </div>
                                                </div>

                                                <div className="flex-none">
                                                  <button
                                                    onClick={() =>
                                                      deleteSet(
                                                        item._id,
                                                        setIdx,
                                                      )
                                                    }
                                                    className="p-2 rounded-md hover:bg-gray-200"
                                                    title="Delete set"
                                                  >
                                                    <RiDeleteBin4Line
                                                      color="#666666"
                                                      size={18}
                                                    />
                                                  </button>
                                                </div>
                                              </div>
                                              {/* notes */}
                                              <div>
                                                <label className="block text-slate100 text-xs font-normal capitalize mb-1">
                                                  Notes
                                                </label>
                                                <textarea
                                                  placeholder="Notes"
                                                  value={set.notes || ""}
                                                  className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                  onChange={(e) =>
                                                    updateSet(
                                                      item._id,
                                                      setIdx,
                                                      "notes",
                                                      e.target.value,
                                                    )
                                                  }
                                                  rows={3}
                                                />
                                              </div>
                                            </div>
                                          </>
                                        ),
                                      )}
                                    </div>

                                    <div className="mt-4 pt-4 border-t border-tblBorder">
                                      <button
                                        onClick={() => addSet(item._id)}
                                        className="text-slate100 text-xs font-medium flex items-center gap-2 hover:text-dark"
                                      >
                                        <MdAdd color="#666666" size={14} /> Add
                                        Set
                                      </button>
                                    </div>
                                  </div>
                                )}

                                {item.type === "superset" && (
                                  <div className="space-y-2">
                                    {/* 👉 Drag-and-drop reorder mode */}
                                    {ssreorderMode === item._id ? (
                                      <DndContext
                                        onDragEnd={(e) =>
                                          handleSupersetReorderEnd(
                                            e,
                                            activeWeek,
                                            activeDay,
                                            item._id,
                                          )
                                        }
                                      >
                                        {item.superset?.exercises?.map(
                                          (sup, sIdx) => (
                                            <DroppableSSEX
                                              key={sup._id}
                                              id={sup._id}
                                            >
                                              <DraggableSSEXItem
                                                id={sup._id}
                                                itemIndex={sIdx}
                                                item={sup}
                                              />
                                            </DroppableSSEX>
                                          ),
                                        )}
                                      </DndContext>
                                    ) : (
                                      // 👉 Normal UI
                                      item.superset?.exercises?.map(
                                        (sup, sIdx) => {
                                          const isOpen =
                                            openSupersetExercise.itemId ===
                                              item._id &&
                                            openSupersetExercise.sIdx === sIdx;

                                          return (
                                            <div
                                              key={sIdx}
                                              className="group bg-white rounded-10 border border-tblBorder overflow-hidden"
                                            >
                                              {/* Header with Toggle & Delete */}
                                              <div className="bg-tblHead py-3 px-4 flex justify-between items-center gap-4">
                                                <div className="w-full flex max-[430px]:flex-col max-[430px]:items-start items-center gap-4">
                                                  {/* <div className="font-semibold text-sm">
                                                    {sup.exercise_id?.title ||
                                                      `Exercise ${sIdx + 1}`}
                                                  </div> */}

                                                  {(() => {
                                                    const exerciseObj =
                                                      getExerciseObject(
                                                        sup.exercise_id,
                                                        exerciseLibrary,
                                                      );
                                                    return (
                                                      exerciseObj?.video_url && (
                                                        <div className="relative flex-none size-12 md:size-16 border border-tblBorder rounded-lg">
                                                          <img
                                                            src={`https://img.youtube.com/vi/${getYouTubeVideoId(exerciseObj.video_url)}/0.jpg`}
                                                            alt="Video thumbnail"
                                                            className="w-full h-full rounded-lg object-cover"
                                                          />
                                                          <button
                                                            className="text-white text-xl absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                                                            onClick={(e) => {
                                                              e.preventDefault();
                                                              setVideoUrlToPlay(
                                                                exerciseObj.video_url,
                                                              );
                                                            }}
                                                          >
                                                            ▶
                                                          </button>
                                                        </div>
                                                      )
                                                    );
                                                  })()}
                                                  {/* {sup.exercise_id?.title ||
                                                      `Exercise ${sIdx + 1}`} */}

                                                  {sup.exercise_id?.title ? (
                                                    <div className="w-full">
                                                      <span className="block text-slate100 font-normal text-sm mb-1">
                                                        Exercise:
                                                      </span>
                                                      <p className="w-full bg-white border border-tblBorder font-normal text-sm text-dark py-2.5 px-3 rounded-md outline-none">
                                                        {sup.exercise_id?.title}
                                                      </p>
                                                    </div>
                                                  ) : (
                                                    <>{`Exercise ${sIdx + 1}`}</>
                                                  )}
                                                </div>

                                                <div className="flex items-center gap-2">
                                                  <button
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleDeleteSupersetExercise(
                                                        item._id,
                                                        sup._id,
                                                      );
                                                    }}
                                                    className="p-1.5 rounded hover:bg-gray-200"
                                                  >
                                                    <RiDeleteBin4Line
                                                      color="#666666"
                                                      size={20}
                                                    />
                                                  </button>
                                                  <button
                                                    onClick={() =>
                                                      setOpenSupersetExercise(
                                                        isOpen
                                                          ? {
                                                              itemId: null,
                                                              sIdx: null,
                                                            }
                                                          : {
                                                              itemId: item._id,
                                                              sIdx,
                                                            },
                                                      )
                                                    }
                                                    className="p-2 rounded hover:bg-gray-200"
                                                  >
                                                    <MdKeyboardArrowDown
                                                      color="#6A7282"
                                                      size={20}
                                                      className={`${isOpen ? "rotate-180" : ""}`}
                                                    />
                                                  </button>
                                                </div>
                                              </div>

                                              {/* Collapsible Content */}
                                              {isOpen && (
                                                <div className="px-3 py-2 text-sm text-gray-700 border-t">
                                                  <div className="mt-2 space-y-4">
                                                    {sup.sets?.map(
                                                      (set, setIdx) => (
                                                        <div
                                                          key={setIdx}
                                                          className="space-y-4"
                                                        >
                                                          <div className="p-3 bg-tblHead border border-tblBorder rounded-10 flex items-center justify-between gap-3">
                                                            <div className="flex flex-wrap gap-3">
                                                              <div className="min-w-20 flex-1">
                                                                <input
                                                                  type="number"
                                                                  className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                  value={
                                                                    set.reps ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    updateSupersetSet(
                                                                      item._id,
                                                                      sIdx,
                                                                      setIdx,
                                                                      "reps",
                                                                      e.target
                                                                        .value,
                                                                    )
                                                                  }
                                                                  placeholder="Reps"
                                                                />
                                                                <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                                  reps
                                                                </label>
                                                              </div>
                                                              <div className="min-w-20 flex-1">
                                                                <input
                                                                  type="number"
                                                                  className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                  value={
                                                                    set.weight ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    updateSupersetSet(
                                                                      item._id,
                                                                      sIdx,
                                                                      setIdx,
                                                                      "weight",
                                                                      e.target
                                                                        .value,
                                                                    )
                                                                  }
                                                                  placeholder="Weight"
                                                                />
                                                                <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                                  weight
                                                                </label>
                                                              </div>
                                                              <div className="min-w-20 flex-1">
                                                                <select
                                                                  className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                  value={
                                                                    set.unit ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    updateSupersetSet(
                                                                      item._id,
                                                                      sIdx,
                                                                      setIdx,
                                                                      "unit",
                                                                      e.target
                                                                        .value,
                                                                    )
                                                                  }
                                                                >
                                                                  <option value="">
                                                                    — Unit —
                                                                  </option>
                                                                  <option value="%">
                                                                    %
                                                                  </option>
                                                                  <option value="hide">
                                                                    hide
                                                                  </option>
                                                                  <option value="time">
                                                                    Time
                                                                  </option>
                                                                </select>
                                                                <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                                  unit
                                                                </label>
                                                              </div>
                                                              {/* Time Dropdown (only when unit is "time") */}
                                                              {set.unit ===
                                                                "time" && (
                                                                <div className="min-w-20 flex-1">
                                                                  <select
                                                                    className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                    value={
                                                                      set.time ||
                                                                      ""
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      updateSupersetSet(
                                                                        item._id,
                                                                        sIdx,
                                                                        setIdx,
                                                                        "time",
                                                                        e.target
                                                                          .value,
                                                                      )
                                                                    }
                                                                  >
                                                                    <option value="">
                                                                      Select
                                                                      time
                                                                    </option>
                                                                    {TIME_OPTIONS.map(
                                                                      (
                                                                        label,
                                                                      ) => (
                                                                        <option
                                                                          key={
                                                                            label
                                                                          }
                                                                          value={
                                                                            label
                                                                          }
                                                                        >
                                                                          {
                                                                            label
                                                                          }
                                                                        </option>
                                                                      ),
                                                                    )}
                                                                  </select>
                                                                  <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                                    Time
                                                                  </label>
                                                                </div>
                                                              )}

                                                              <div className="min-w-20 flex-1">
                                                                <select
                                                                  className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                  value={
                                                                    set.goal ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    updateSupersetSet(
                                                                      item._id,
                                                                      sIdx,
                                                                      setIdx,
                                                                      "goal",
                                                                      e.target
                                                                        .value,
                                                                    )
                                                                  }
                                                                >
                                                                  <option value="">
                                                                    — Goal —
                                                                  </option>
                                                                  <option value="< 0.5 m/s (Absolute Strength)">
                                                                    &lt; 0.5 m/s
                                                                    (Absolute
                                                                    Strength)
                                                                  </option>
                                                                  <option value="0.5 - 0.75 m/s (Accelerative Strength)">
                                                                    0.5 - 0.75
                                                                    m/s
                                                                    (Accelerative
                                                                    Strength)
                                                                  </option>
                                                                  <option value="0.75 - 1 m/s (Strength Speed)">
                                                                    0.75 - 1 m/s
                                                                    (Strength
                                                                    Speed)
                                                                  </option>
                                                                  <option value="1 - 1.3 m/s (Speed Strength)">
                                                                    1 - 1.3 m/s
                                                                    (Speed
                                                                    Strength)
                                                                  </option>
                                                                  <option value="> 1.3 m/s (Starting Strength)">
                                                                    &gt; 1.3 m/s
                                                                    (Starting
                                                                    Strength)
                                                                  </option>
                                                                  <option value="> 2 m/s (Speed)">
                                                                    &gt; 2 m/s
                                                                    (Speed)
                                                                  </option>
                                                                </select>
                                                                <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                                  Goal
                                                                </label>
                                                              </div>

                                                              <div className="min-w-20 flex-1">
                                                                <input
                                                                  type="text"
                                                                  className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                  value={
                                                                    set.rest ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    updateSupersetSet(
                                                                      item._id,
                                                                      sIdx,
                                                                      setIdx,
                                                                      "rest",
                                                                      e.target
                                                                        .value,
                                                                    )
                                                                  }
                                                                  placeholder="Rest"
                                                                />
                                                                <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                                  Rest
                                                                </label>
                                                              </div>
                                                            </div>

                                                            <div className="flex-none">
                                                              <button
                                                                className="p-2 rounded-md hover:bg-gray-200"
                                                                onClick={() =>
                                                                  deleteSupersetSet(
                                                                    item._id,
                                                                    sIdx,
                                                                    setIdx,
                                                                  )
                                                                }
                                                              >
                                                                <RiDeleteBin4Line
                                                                  color="#666666"
                                                                  size={18}
                                                                />
                                                              </button>
                                                            </div>
                                                          </div>

                                                          {/* notes */}
                                                          <div>
                                                            <label className="block text-slate100 text-xs font-normal capitalize mb-1">
                                                              Notes
                                                            </label>
                                                            <textarea
                                                              className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                              value={
                                                                set.notes || ""
                                                              }
                                                              onChange={(e) =>
                                                                updateSupersetSet(
                                                                  item._id,
                                                                  sIdx,
                                                                  setIdx,
                                                                  "notes",
                                                                  e.target
                                                                    .value,
                                                                )
                                                              }
                                                              placeholder="Notes"
                                                              rows={3}
                                                            />
                                                          </div>
                                                        </div>
                                                      ),
                                                    )}
                                                    <div className="mt-4 pt-4 border-t border-tblBorder">
                                                      <button
                                                        className="text-slate100 text-xs font-medium flex items-center gap-2 hover:text-dark"
                                                        onClick={() =>
                                                          addSupersetSet(
                                                            item._id,
                                                            sIdx,
                                                          )
                                                        }
                                                      >
                                                        <MdAdd
                                                          color="#666666"
                                                          size={14}
                                                        />{" "}
                                                        Add Set
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          );
                                        },
                                      )
                                    )}

                                    {/* ➕ Add Exercise Form */}
                                    {showSupersetAddForm === item._id ? (
                                      <div className="bg-tblHead p-4 rounded-14 border border-tblBorder mt-4">
                                        <div className="w-full flex flex-wrap items-end gap-3">
                                          <SingleSelectExerciseList
                                            exercises={exerciseLibrary}
                                            value={
                                              selectedSupersetExerciseId || ""
                                            }
                                            onChange={(val) =>
                                              setSelectedSupersetExerciseId(val)
                                            }
                                          />

                                          <div className="flex gap-2">
                                            <button
                                              onClick={() =>
                                                handleAddSupersetExercise(
                                                  item._id,
                                                )
                                              }
                                              className="px-6 py-2 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black"
                                            >
                                              Add
                                            </button>
                                            <button
                                              onClick={() =>
                                                setShowSupersetAddForm(null)
                                              }
                                              className="px-4 py-2 bg-white border border-tblBorder text-dark font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black hover:text-white h-fit"
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        <div className="pt-2 block">
                                          <button
                                            onClick={() =>
                                              setShowSupersetAddForm(item._id)
                                            }
                                            className="text-slate100 font-normal text-sm hover:text-dark flex items-center gap-2"
                                          >
                                            <MdAdd color="#666" /> Add Exercise
                                          </button>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                )}

                                {item.type === "circuit" && (
                                  <div className="space-y-2">
                                    {/* 👉 Drag-and-drop reorder mode */}
                                    {ccreorderMode === item._id ? (
                                      <DndContext
                                        onDragEnd={(e) =>
                                          handleCircuitReorderEnd(
                                            e,
                                            activeWeek,
                                            activeDay,
                                            item._id,
                                          )
                                        }
                                      >
                                        {item.circuit?.exercises?.map(
                                          (sup, sIdx) => (
                                            <DroppableCCEX
                                              key={sup._id}
                                              id={sup._id}
                                            >
                                              <DraggableCCEXItem
                                                id={sup._id}
                                                itemIndex={sIdx}
                                                item={sup}
                                              />
                                            </DroppableCCEX>
                                          ),
                                        )}
                                      </DndContext>
                                    ) : (
                                      // 👉 Normal UI
                                      item.circuit?.exercises?.map(
                                        (sup, sIdx) => {
                                          const isOpen =
                                            openCircuitExercise.itemId ===
                                              item._id &&
                                            openCircuitExercise.sIdx === sIdx;

                                          return (
                                            <div
                                              key={sIdx}
                                              className="group bg-white rounded-10 border border-tblBorder overflow-hidden"
                                            >
                                              {/* Header with Toggle & Delete */}
                                              <div className="bg-tblHead py-3 px-4 flex justify-between items-center gap-4">
                                                <div className="w-full flex max-[430px]:flex-col max-[430px]:items-start items-center gap-4">
                                                  {(() => {
                                                    const exerciseObj =
                                                      getExerciseObject(
                                                        sup.exercise_id,
                                                        exerciseLibrary,
                                                      );
                                                    return (
                                                      exerciseObj?.video_url && (
                                                        <div className="relative size-12 md:size-16 border border-tblBorder rounded-lg">
                                                          <img
                                                            src={`https://img.youtube.com/vi/${getYouTubeVideoId(exerciseObj.video_url)}/0.jpg`}
                                                            alt="Video thumbnail"
                                                            className="w-full h-full rounded-lg object-cover"
                                                          />
                                                          <button
                                                            className="text-white text-xl absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                                                            onClick={(e) => {
                                                              e.preventDefault();
                                                              setVideoUrlToPlay(
                                                                exerciseObj.video_url,
                                                              );
                                                            }}
                                                          >
                                                            ▶
                                                          </button>
                                                        </div>
                                                      )
                                                    );
                                                  })()}
                                                  {/* <div className="font-semibold text-sm">
                                                    {sup.exercise_id?.title ||
                                                      `Exercise ${sIdx + 1}`}
                                                  </div> */}

                                                  {sup.exercise_id?.title ? (
                                                    <div className="w-full">
                                                      <span className="block text-slate100 font-normal text-sm mb-1">
                                                        Exercise:
                                                      </span>
                                                      <p className="w-full bg-white border border-tblBorder font-normal text-sm text-dark py-2.5 px-3 rounded-md outline-none">
                                                        {sup.exercise_id?.title}
                                                      </p>
                                                    </div>
                                                  ) : (
                                                    <>{`Exercise ${sIdx + 1}`}</>
                                                  )}
                                                </div>

                                                <div className="flex items-center gap-2">
                                                  <button
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleDeleteCircuitExercise(
                                                        item._id,
                                                        sup._id,
                                                      );
                                                    }}
                                                    className="p-1.5 rounded hover:bg-gray-200"
                                                  >
                                                    <RiDeleteBin4Line
                                                      color="#666666"
                                                      size={20}
                                                    />
                                                  </button>

                                                  <button
                                                    onClick={() =>
                                                      setOpenCircuitExercise(
                                                        isOpen
                                                          ? {
                                                              itemId: null,
                                                              sIdx: null,
                                                            }
                                                          : {
                                                              itemId: item._id,
                                                              sIdx,
                                                            },
                                                      )
                                                    }
                                                    className="p-2 rounded hover:bg-gray-200"
                                                  >
                                                    <MdKeyboardArrowDown
                                                      color="#6A7282"
                                                      size={20}
                                                      className={`${isOpen ? "rotate-180" : ""}`}
                                                    />
                                                  </button>
                                                </div>
                                              </div>

                                              {/* Collapsible Content */}
                                              {isOpen && (
                                                <div className="">
                                                  {/* You can customize this with set/rep data if needed */}
                                                  {/* Add more fields as needed */}
                                                  <div className="p-4 space-y-6 bg-white border-t border-tblBorder">
                                                    {sup.sets?.map(
                                                      (set, setIdx) => (
                                                        <div
                                                          key={setIdx}
                                                          className="space-y-4"
                                                        >
                                                          <div className="p-3 bg-tblHead border border-tblBorder rounded-10 flex items-center justify-between gap-3">
                                                            <div className="flex flex-wrap gap-3">
                                                              <div className="min-w-20 flex-1">
                                                                <input
                                                                  type="number"
                                                                  className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                  value={
                                                                    set.reps ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    updateCircuitSet(
                                                                      item._id,
                                                                      sIdx,
                                                                      setIdx,
                                                                      "reps",
                                                                      e.target
                                                                        .value,
                                                                    )
                                                                  }
                                                                  placeholder="Reps"
                                                                />
                                                                <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                                  reps
                                                                </label>
                                                              </div>
                                                              <div className="min-w-20 flex-1">
                                                                <input
                                                                  type="number"
                                                                  className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                  value={
                                                                    set.weight ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    updateCircuitSet(
                                                                      item._id,
                                                                      sIdx,
                                                                      setIdx,
                                                                      "weight",
                                                                      e.target
                                                                        .value,
                                                                    )
                                                                  }
                                                                  placeholder="Weight"
                                                                />
                                                                <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                                  weight
                                                                </label>
                                                              </div>
                                                              <div className="min-w-20 flex-1">
                                                                <select
                                                                  className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                  value={
                                                                    set.unit ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    updateCircuitSet(
                                                                      item._id,
                                                                      sIdx,
                                                                      setIdx,
                                                                      "unit",
                                                                      e.target
                                                                        .value,
                                                                    )
                                                                  }
                                                                >
                                                                  <option value="">
                                                                    — Unit —
                                                                  </option>
                                                                  <option value="%">
                                                                    %
                                                                  </option>
                                                                  <option value="hide">
                                                                    hide
                                                                  </option>
                                                                  <option value="time">
                                                                    Time
                                                                  </option>
                                                                </select>
                                                                <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                                  unit
                                                                </label>
                                                              </div>
                                                              {/* Time Dropdown (only when unit is "time") */}
                                                              {set.unit ===
                                                                "time" && (
                                                                <div className="min-w-20 flex-1">
                                                                  <select
                                                                    className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                    value={
                                                                      set.time ||
                                                                      ""
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      updateCircuitSet(
                                                                        item._id,
                                                                        sIdx,
                                                                        setIdx,
                                                                        "time",
                                                                        e.target
                                                                          .value,
                                                                      )
                                                                    }
                                                                  >
                                                                    <option value="">
                                                                      {" "}
                                                                      Select
                                                                      time{" "}
                                                                    </option>
                                                                    {TIME_OPTIONS.map(
                                                                      (
                                                                        label,
                                                                      ) => (
                                                                        <option
                                                                          key={
                                                                            label
                                                                          }
                                                                          value={
                                                                            label
                                                                          }
                                                                        >
                                                                          {
                                                                            label
                                                                          }
                                                                        </option>
                                                                      ),
                                                                    )}
                                                                  </select>
                                                                  <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                                    time
                                                                  </label>
                                                                </div>
                                                              )}
                                                              <div className="min-w-20 flex-1">
                                                                <select
                                                                  className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none1"
                                                                  value={
                                                                    set.goal ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    updateCircuitSet(
                                                                      item._id,
                                                                      sIdx,
                                                                      setIdx,
                                                                      "goal",
                                                                      e.target
                                                                        .value,
                                                                    )
                                                                  }
                                                                >
                                                                  <option value="">
                                                                    {" "}
                                                                    — Goal
                                                                    —{" "}
                                                                  </option>
                                                                  <option value="< 0.5 m/s (Absolute Strength)">
                                                                    {" "}
                                                                    &lt; 0.5 m/s
                                                                    (Absolute
                                                                    Strength){" "}
                                                                  </option>
                                                                  <option value="0.5 - 0.75 m/s (Accelerative Strength)">
                                                                    {" "}
                                                                    0.5 - 0.75
                                                                    m/s
                                                                    (Accelerative
                                                                    Strength){" "}
                                                                  </option>
                                                                  <option value="0.75 - 1 m/s (Strength Speed)">
                                                                    {" "}
                                                                    0.75 - 1 m/s
                                                                    (Strength
                                                                    Speed){" "}
                                                                  </option>
                                                                  <option value="1 - 1.3 m/s (Speed Strength)">
                                                                    {" "}
                                                                    1 - 1.3 m/s
                                                                    (Speed
                                                                    Strength){" "}
                                                                  </option>
                                                                  <option value="> 1.3 m/s (Starting Strength)">
                                                                    {" "}
                                                                    &gt; 1.3 m/s
                                                                    (Starting
                                                                    Strength){" "}
                                                                  </option>
                                                                  <option value="> 2 m/s (Speed)">
                                                                    {" "}
                                                                    &gt; 2 m/s
                                                                    (Speed){" "}
                                                                  </option>
                                                                </select>
                                                                <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                                  goal
                                                                </label>
                                                              </div>

                                                              <div className="min-w-20 flex-1">
                                                                <input
                                                                  type="text"
                                                                  className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                  value={
                                                                    set.rest ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    updateCircuitSet(
                                                                      item._id,
                                                                      sIdx,
                                                                      setIdx,
                                                                      "rest",
                                                                      e.target
                                                                        .value,
                                                                    )
                                                                  }
                                                                  placeholder="Rest"
                                                                />
                                                                <label className="block text-[#99A1AF] text-xs font-normal capitalize mt-1">
                                                                  rest
                                                                </label>
                                                              </div>
                                                            </div>

                                                            <div className="flex-none">
                                                              <button
                                                                className="p-2 rounded-md hover:bg-gray-200"
                                                                onClick={() =>
                                                                  deleteCircuitSet(
                                                                    item._id,
                                                                    sIdx,
                                                                    setIdx,
                                                                  )
                                                                }
                                                              >
                                                                <RiDeleteBin4Line
                                                                  color="#666666"
                                                                  size={18}
                                                                />
                                                              </button>
                                                            </div>
                                                          </div>
                                                          <div>
                                                            <label className="block text-slate100 text-xs font-normal capitalize mt-1">
                                                              notes
                                                            </label>
                                                            <textarea
                                                              className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                              value={
                                                                set.notes || ""
                                                              }
                                                              onChange={(e) =>
                                                                updateCircuitSet(
                                                                  item._id,
                                                                  sIdx,
                                                                  setIdx,
                                                                  "notes",
                                                                  e.target
                                                                    .value,
                                                                )
                                                              }
                                                              placeholder="Notes"
                                                              rows={3}
                                                            />
                                                          </div>
                                                        </div>
                                                      ),
                                                    )}
                                                    <div className="mt-4 pt-4 border-t border-tblBorder">
                                                      <button
                                                        className="text-slate100 text-xs font-medium flex items-center gap-2 hover:text-dark"
                                                        onClick={() =>
                                                          addCircuitSet(
                                                            item._id,
                                                            sIdx,
                                                          )
                                                        }
                                                      >
                                                        <MdAdd
                                                          color="#666666"
                                                          size={14}
                                                        />{" "}
                                                        Add Set
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          );
                                        },
                                      )
                                    )}

                                    {/* Add Exercise Button */}
                                    {showCircuitAddForm === item._id ? (
                                      <div className="bg-tblHead p-4 rounded-14 border border-tblBorder mt-4">
                                        <div className="w-full flex flex-wrap items-end gap-3">
                                          <SingleSelectExerciseList
                                            exercises={exerciseLibrary}
                                            value={
                                              selectedCircuitExerciseId || ""
                                            }
                                            onChange={(val) =>
                                              setSelectedCircuitExerciseId(val)
                                            }
                                          />

                                          <div className="flex gap-2">
                                            <button
                                              onClick={() =>
                                                handleAddCircuitExercise(
                                                  item._id,
                                                )
                                              }
                                              className="px-6 py-2 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black"
                                            >
                                              Add
                                            </button>
                                            <button
                                              onClick={() =>
                                                setShowCircuitAddForm(null)
                                              }
                                              className="px-4 py-2 bg-white border border-tblBorder text-dark font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black hover:text-white h-fit"
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        <div className="pt-2">
                                          <button
                                            onClick={() =>
                                              setShowCircuitAddForm(item._id)
                                            }
                                            className="text-slate100 font-normal text-sm hover:text-dark flex items-center gap-2"
                                          >
                                            <MdAdd color="#666" /> Add Exercise
                                          </button>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            </details>
                          );
                        },
                      )}
                    </div>
                  </div>
                  ) : (
                    items.length === 0 && (
                      <div className="w-full max-w-screen-xl">
                        {/* <h2 className="text-xl font-medium mb-4">
                          Start by choosing a training workout template
                        </h2> */}

                        {loading ? (
                          <p className="bg-gray-100 rounded-sm p-2 font-medium text-gray-600">
                            Loading available templates...
                          </p>
                        ) : error ? (
                          <p className="bg-red-100 rounded-sm p-2 font-medium text-red-500">{error}</p>
                        ) : trainingFocuses.length === 0 ? (
                          <p className="bg-gray-100 rounded-sm p-2 font-medium text-gray-500">
                            No training workout templates available.
                          </p>
                        ) : (
                          <div className="overflow-x-auto">
                            <div className="relative w-full min-w-64 max-w-64 mb-4">
                              <input
                                type="text"
                                value={searchTerm}
                                onChange={(e) => {
                                  setSearchTerm(e.target.value);
                                  setCurrentPage(1); // reset to first page on search
                                }}
                                placeholder="Search by title or phase..."
                                className="w-full bg-white p-3 border border-black/10 rounded-lg placeholder:text-slate100 font-inter font-normal leading-3 text-sm pl-10"
                              />
                              <span className="absolute top-1/2 -translate-y-1/2 left-3">
                                <CiSearch color="#666666" size={20} />
                              </span>
                            </div>
                            
                            <div className="p-4 bg-white rounded-10 border border-tblBorder">
                              <div className="rounded-10 border border-tblBorder md:max-h-[500px] overflow-auto show-scrollbar mb-5">
                                <table className="min-w-full text-sm text-left">
                                  <tbody className="divide-y divide-tblBorder">
                                    {paginatedTemplates.map((template) => (
                                      <React.Fragment key={template._id}>
                                        <tr className="hover:bg-gray-50">
                                          <td className="p-4">
                                            <div>
                                              <p className="text-dark text-sm font-medium capitalize mb-1">
                                                {template.training_focus}
                                              </p>
                                              <p className="text-slate100 text-xs font-medium capitalize">
                                                {template.training_phase}
                                              </p>
                                            </div>
                                          </td>
                                          <td className="p-4">
                                            <div className="flex justify-end items-center gap-5">
                                              <p className="text-slate100 text-sm font-medium capitalize">
                                                {template.items?.length || 0}{" "}
                                                item(s)
                                              </p>
                                              <button
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleUseFocusTemplate(
                                                    template,
                                                  );
                                                }}
                                                className="px-3 py-2 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black"
                                              >
                                                Use
                                              </button>

                                              <button
                                                onClick={() =>
                                                  toggleExpand(template._id)
                                                }
                                                className="p-2 rounded hover:bg-gray-200"
                                              >
                                                {expandedRow === template._id ? (
                                                  <>
                                                    <MdKeyboardArrowUp
                                                      color="#6A7282"
                                                      size={20}
                                                    />
                                                  </>
                                                ) : (
                                                  <>
                                                    {" "}
                                                    <MdKeyboardArrowDown
                                                      color="#6A7282"
                                                      size={20}
                                                    />
                                                  </>
                                                )}
                                              </button>
                                            </div>
                                          </td>
                                        </tr>

                                        {/* Expanded Row */}
                                        {expandedRow === template._id && (
                                          <tr>
                                            <td
                                              colSpan={4}
                                              className="bg-bgBase overflow-auto show-scrollbar p-4"
                                            >
                                              {template.items?.length > 0 ? (
                                                <div className=" bg-white border border-tblBorder rounded-10 overflow-hidden">
                                                  <table className="w-full">
                                                    <thead>
                                                      <tr className="bg-[#FAFAFA] text-slate100 text-xs font-medium ">
                                                        <th className="py-3 px-4">
                                                          #
                                                        </th>
                                                        <th className="py-3 px-4">
                                                          Type
                                                        </th>
                                                        <th className="py-3 px-4">
                                                          Title
                                                        </th>
                                                        <th className="py-3 px-4">
                                                          {" "}
                                                          Details{" "}
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {template.items.map(
                                                        (item, index) => {
                                                          let type = item.type;
                                                          let title = "";
                                                          let detail = "";

                                                          if (
                                                            type === "exercise"
                                                          ) {
                                                            title =
                                                              item.exercise
                                                                .exercise_id
                                                                ?.title ||
                                                              "Untitled";
                                                          } else if (
                                                            type === "superset"
                                                          ) {
                                                            title =
                                                              item.superset
                                                                .title ||
                                                              "Untitled";
                                                            detail =
                                                              item.superset.exercises
                                                                .map(
                                                                  (ex) =>
                                                                    ex.exercise_id
                                                                      ?.title ||
                                                                    "Exercise",
                                                                )
                                                                .join(", ");
                                                          } else if (
                                                            type === "circuit"
                                                          ) {
                                                            title =
                                                              item.circuit
                                                                .title ||
                                                              "Untitled";
                                                            detail =
                                                              item.circuit.exercises
                                                                .map(
                                                                  (ex) =>
                                                                    ex.exercise_id
                                                                      ?.title ||
                                                                    "Exercise",
                                                                )
                                                                .join(", ");
                                                          }

                                                          return (
                                                            <tr
                                                              key={index}
                                                              className="border-t text-slate100 text-sm font-normal"
                                                            >
                                                              <td className="py-3 px-4">
                                                                {index + 1}
                                                              </td>
                                                              <td className="py-3 px-4 capitalize">
                                                                {type}
                                                              </td>
                                                              <td className="py-3 px-4 capitalize">
                                                                {title}
                                                              </td>
                                                              <td className="py-3 px-4 text-dark font-medium">
                                                                {detail || "-"}
                                                              </td>
                                                            </tr>
                                                          );
                                                        },
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              ) : (
                                                <p className="text-gray-500">
                                                  No items in this template.
                                                </p>
                                              )}
                                            </td>
                                          </tr>
                                        )}
                                      </React.Fragment>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            <div className="mt-8 flex max-md:flex-wrap justify-between items-center gap-2 text-sm">
                              <button
                                className={`px-4 py-2 min-w-20 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm ${
                                  currentPage === 1
                                    ? "cursor-not-allowed"
                                    : "text-black"
                                }`}
                                disabled={currentPage === 1}
                                onClick={() =>
                                  setCurrentPage((prev) => prev - 1)
                                }
                              >
                                <MdKeyboardArrowLeft size={20} /> Previous
                              </button>
                              <span className="text-dark font-inter font-normal text-sm">
                                Page {currentPage} of {totalPages}
                              </span>
                              <button
                                className={`px-4 py-2 min-w-20 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm ${
                                  currentPage === totalPages
                                    ? "cursor-not-allowed"
                                    : "text-black"
                                }`}
                                disabled={currentPage === totalPages}
                                onClick={() =>
                                  setCurrentPage((prev) => prev + 1)
                                }
                              >
                                Next <MdKeyboardArrowRight size={20} />
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {videoUrlToPlay && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
          <div className="bg-white p-4 rounded-lg shadow-lg w-11/12 max-w-2xl relative">
            <button
              onClick={() => setVideoUrlToPlay(null)}
              className="absolute top-2 right-3 text-xl text-gray-700 hover:text-black"
            >
              ✖
            </button>
            <iframe
              width="100%"
              height="400"
              src={videoUrlToPlay.replace("watch?v=", "embed/")}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Exercise Video"
              className="rounded"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export const DraggableEXItem = ({ itemIndex, id, item }) => {
  const navigate = useNavigate();
  const [dragMode, setDragMode] = useState(true);

  const { attributes, listeners, setNodeRef, transform } = useDraggable({ id });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        transition: "none",
      }
    : undefined;

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...(dragMode ? listeners : {})}
      style={style}
      className="bg-white border border-tblBorder p-2 rounded-10"
    >
      {item.type === "exercise" && (
        <h4 className="font-medium text-sm leading-tight m-0">
          Exercise: {item.exercise?.exercise_id?.title}
        </h4>
      )}
      {item.type === "superset" && (
        <h4 className="font-medium text-sm leading-tight m-0">
          Superset: {item.superset?.title}
        </h4>
      )}
      {item.type === "circuit" && (
        <h4 className="font-medium text-sm leading-tight m-0">
          Circuit: {item.circuit?.title}
        </h4>
      )}
    </div>
  );
};

const DroppableEX = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      className={`transition-all duration-150 ease-in-out ${
        isOver ? "bg-gray-100" : ""
      } px-1 py-1 rounded-md`}
    >
      {children}
    </div>
  );
};

const DroppableSSEX = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      className={`transition-all duration-150 ease-in-out ${
        isOver ? "bg-gray-100" : ""
      } px-1 py-1 rounded-md`} // ↓ reduced padding
    >
      {children}
    </div>
  );
};

export const DraggableSSEXItem = ({ itemIndex, id, item }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({ id });

  const style = {
    ...(transform && {
      transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      transition: "none",
    }),
    marginBottom: "0px", // small gap between items
  };

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={style}
      className="bg-white border rounded shadow-sm px-3 py-2"
    >
      <h4 className="font-semibold text-sm leading-tight m-0">
        {item.exercise_id?.title}
      </h4>
    </div>
  );
};

const DroppableCCEX = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      className={`transition-all duration-150 ease-in-out ${
        isOver ? "bg-gray-100" : ""
      } px-2 py-1 rounded-md`} // Tight padding
    >
      {children}
    </div>
  );
};

export const DraggableCCEXItem = ({ itemIndex, id, item }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({ id });

  const style = {
    ...(transform && {
      transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      transition: "none",
    }),
    marginBottom: "0px",
  };

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={style}
      className="bg-white border rounded shadow-sm p-2"
    >
      <div className="font-medium text-sm leading-tight">
        {item.exercise_id?.title}
      </div>
    </div>
  );
};
